import { RevenueType, Revenue, MerchSource } from "@arelia-types/earnings";

export const getApiResponseMapper = (revenues: Revenue[]): any[] => {
  if (!revenues) {
    return [];
  }

  const map = revenues.reduce((res: any[], curr) => {
    let rowData: any = {
      date: curr.date,
      id: curr.id as string,
      name: curr.name,
      location: curr.location,
      isReadOnly: curr.isReadOnly,
      amount: curr.amount,
      merchSource: (curr.merchSource as MerchSource)
    };

    curr.subRevenues?.forEach(subRev => {
      rowData = {
        ...rowData,
        [subRev.type]: subRev.amount
      };
    });

    return [...res, rowData];
  }, [])

  return map;
}

export const postApiResponseMapper = (rowsData: any[]): Revenue[] => {
  return rowsData.map(rowData => {
    const { id, location, date, amount } = rowData;
    const revenue: Revenue = {
      id: id as string,
      name: "Performance Revenue",
      location: location as string,
      date: date as string,
      isReadOnly: true,
      amount: amount as number,
      subRevenues: []
    };

    if (rowData[RevenueType.Tips]) {
      revenue.subRevenues.push({
        name: location as string,
        amount: rowData[RevenueType.Tips] as number,
        type: RevenueType.Tips
      });
      delete rowData[RevenueType.Tips];
    }

    if (rowData[RevenueType.Merch]) {
      revenue.subRevenues.push({
        name: location as string,
        amount: rowData[RevenueType.Merch] as number,
        type: RevenueType.Merch
      });
      delete rowData[RevenueType.Merch];
    }

    return revenue;
  });
}